<template>
  <div class="m7-sounds">
    <v-list bg-color="transparent" density="compact">
      <v-list-item
        v-for="voice in VOICES"
        :key="voice.id"
        class="m7-sounds__item"
        :class="{ 'is-selected': voice.id === store.settings.voice }"
        @click="store.update('voice', voice.id)"
      >
        <template #prepend>
          <!-- Fixed-width slot so the labels don't shift as the tick moves. -->
          <span class="m7-sounds__tick">
            <v-icon v-if="voice.id === store.settings.voice" icon="$check" size="small" color="primary" />
          </span>
        </template>

        <v-list-item-title class="m7-sounds__label">
          {{ $t(`metronome.voices.${voice.labelKey}`) }}
        </v-list-item-title>

        <template #append>
          <v-btn
            icon="$play"
            size="x-small"
            variant="outlined"
            :aria-label="$t('metronome.preview')"
            @click.stop="emit('preview', voice.id)"
          />
        </template>
      </v-list-item>
    </v-list>
  </div>
</template>

<script setup>
import { VOICES } from '~/utils/metronomeVoices'

const emit = defineEmits(['preview'])

const store = useMetronomeStore()
</script>

<style scoped>
.m7-sounds__tick {
  display: inline-flex;
  justify-content: center;
  width: 24px;
  margin-right: 0.5rem;
}

.m7-sounds__label {
  letter-spacing: 0.12em;
  text-transform: uppercase;
  font-size: 0.78rem;
}

.m7-sounds__item.is-selected .m7-sounds__label {
  color: var(--m7-accent);
}
</style>
